import { SessionCreateRequest, UserAttribute } from 'app/shared/models';

export enum UserType {
  Standard = 'standard',
  Pincode = 'pincode'
}

export enum UserStatus {
  Deleted = -1,
  Deactivated = 0,
  Active = 1
}

export interface CreateUser {
  id: number;
  externalId?: string;
  firstName?: string;
  lastName?: string;
  email?: string;
  createTime?: Date;
  status: UserStatus;
  companyId: number;
  baseGroupId: number;
  languageId?: number;
  userType: UserType;
  manuallyEdited?: boolean;
  phoneNumber?: string;
  hierarchyId: number;
  groupId: number;
  excludedFromSurveys?: boolean;

  language?: string;
  userAttributes: UserAttribute[];
  sessionsToCreate?: SessionCreateRequest[];
  sessionsToRemove?: number[];
}

export interface AnonymousUserSettings {
  count: number;
  addToSurvey: boolean;
}

export interface CreateAnonymousUser {
  companyId: number;
  groupId: number;
  hierarchyId: number;
  count: number;
}

export interface MoveUserDto {
  companyId: number;
  hierarchyId: number;
  newGroupId: number;
  userIds: number[];
}

export interface DeleteUserDto {
  companyId: number;
  hierarchyId: number;
  userIds: number[];
}

export interface CreateUserConnection {
  id: number;
  userId: number;
  relationId: number;
  targetUserId: number;
}
